import { I18n } from '@affine/i18n';

const MINUTE_MS = 60 * 1000;
const HOUR_MS = 60 * MINUTE_MS;
const DAY_MS = 24 * HOUR_MS;

/**
 * Human remaining offline-access time ("in 3 Stunden" / "in 3 hours"):
 * minutes below 2 h, hours below 2 days, days above. Rounds up so the
 * warning never understates the time that is left.
 */
export function formatOfflineAccessRemaining(remainingMs: number): string {
  const ms = Math.max(0, remainingMs);
  if (ms < 2 * HOUR_MS) {
    return I18n['com.streamlain.offline-access.remaining.minutes']({
      count: Math.max(1, Math.ceil(ms / MINUTE_MS)),
    });
  }
  if (ms < 2 * DAY_MS) {
    return I18n['com.streamlain.offline-access.remaining.hours']({
      count: Math.ceil(ms / HOUR_MS),
    });
  }
  return I18n['com.streamlain.offline-access.remaining.days']({
    count: Math.ceil(ms / DAY_MS),
  });
}
